<!-- <div class="row">
  <div class="col">
    <fx-page-header title="User Settings" refreshButton="true" url="/app/user-settings"></fx-page-header>
  </div>
</div> -->
<div class="user-settings">
  <div class="row">
    <div class="col">
      <fx-page-header title="User Settings"></fx-page-header>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12">
      <fx-user [groups]="groups" [permission]="permission"></fx-user>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12">
      <fx-group
        [permission]="permission"
        [groups]="groups"
        (dataLoaded)="onGroupLoaded($event)"
      ></fx-group>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <fx-group-operator
        [permission]="permission"
        [groups]="groups"
        (dataLoaded)="onGroupLoaded($event)"
      ></fx-group-operator>
    </div>
  </div>
</div>
